export const validarCPF = (cpf, pais) => {
    cpf = cpf.replace(/[^\d]+/g, '')

    if (cpf.length !== 11 && pais !== 'es-CL') return `CPF deve ter 11 dígitos!`

    if (/^(.)\1+$/.test(cpf)) return 'CPF inválido!'

    let soma = 0
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let resto = 11 - (soma % 11)
    let digito1 = (resto === 10 || resto === 11) ? 0 : resto

    soma = 0
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i)
    }
    resto = 11 - (soma % 11)
    let digito2 = (resto === 10 || resto === 11) ? 0 : resto

    if (digito1 !== parseInt(cpf.charAt(9)) || digito2 !== parseInt(cpf.charAt(10))) {
        return 'CPF inválido!'
    }

    return 'ok'
}
